import React from 'react';
import { ActionButton } from '../common/ActionButton';
import { useSiteState } from '../../state/state';
import { SummaryBlock } from '../common/SummaryBlock';
import { Col, Row } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';

type  RulesStepProps = {
    buttonText: string,
    buttonLoadingText: string,
    buttonLoading: boolean,
    onStepComplete: () => void
}

export const RulesStep = ({ buttonText, buttonLoadingText, buttonLoading, onStepComplete }: RulesStepProps) => {
    const { settings, rules } = useSiteState();

    return (
        <>
            <SummaryBlock display className='summary-block'>
                <Row>
                    <Col className='med-heading heading-move-left'>
                        {settings?.siteRulesHeading}
                    </Col>
                </Row>
                <Row>
                    <Col className="body-text">
                        {rules && <ReactMarkdown linkTarget='_blank' source={rules} allowDangerousHtml={true} />}
                    </Col>
                </Row>
            </SummaryBlock>
            <ActionButton text={buttonLoading ? buttonLoadingText : buttonText} disabled={buttonLoading} onClick={onStepComplete} />
        </>
    )
}
